import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);


import Contacts from './components/AppContacts';

import Projection from './components/Projection';
import Partners from './components/Partners';
import Ost from './components/Ost';


import E404 from './components/E404';




const routes = [{
        path: '',
        redirect: { name: 'sound' }
    },
    {
        name: 'sound',
        path: '/sound',
        component: () =>
            import ( /* webpackChunkName: "sound" */
                "./pages/Sound.vue")
    },
    {
        name: 'light',
        path: '/light',
        component: () =>
            import ( /* webpackChunkName: "light" */
                "./pages/Light.vue")
    },
    {
        path: '/contacts',
        component: Contacts
    },
    {
        name: 'muzinstr',
        path: '/muzinstr',
        component: () =>
            import ( /* webpackChunkName: "muzinstr" */
                "./pages/MuzInstr.vue")
    },
    {
        name: 'projection',
        path: '/projection',
        component: Projection
    },
    {
        name: 'ferms',
        path: '/ferms',
        component: () =>
            import ( /* webpackChunkName: "ferms" */
                "./pages/Ferms.vue")
    },
    {
        name: 'partners',
        path: '/partners',
        component: Partners
    },
    {
        path: '/vitrina',
        component: Ost
    },
    {
        name: 'clients',
        path: '/clients',
        component: () =>
            import ( /* webpackChunkName: "clients" */
                "./pages/Clients.vue")
    },
    {
        name: 'cart',
        path: '/cart',
        component: () =>
            import ( /* webpackChunkName: "cart" */
                "./components/Cart.vue")
    },
    {
        name: 'cartId',
        path: '/cart/:id',
        component: () =>
            import ( /* webpackChunkName: "cartId" */
                "./components/CartID.vue")
    },
    {
        name: 'productId',
        path: '/product/:id',
        props: true,
        component: () =>
            import ( /* webpackChunkName: "productId" */
                "./pages/Product.vue")
    },

    {
        path: '*',
        component: E404
    }
];

export const router = new VueRouter({
    routes,
    mode: 'history'
})